import React from "react";
import Spinner from "../../../components/presentationals/Spinner";
import { TablePagination } from "@mui/material";
import Error from "../../../components/Error";

const SchemeCountTable = ({
  searchFields,
  setSearchFields,
  schemeOverview,
  page,
  rowsPerPage,
  setPage,
  setRowsPerPage,
}) => {
  const convertDateFormat = (date) => {
    const [year, month, day] = date.split("-");
    return day + "-" + month + "-" + year;
  };

  return (
    <div
      className="whitebox wow fadeInUp"
      data-wow-delay=".6s"
      data-wow-duration="0.7s"
    >
      <div className="row forms mt-2">
        <div className="col-md-4 col-lg-4">
          <input
            type="text"
            className="form-control"
            id="fl11"
            value={searchFields?.schemeFilter}
            onChange={(e) => {
              setSearchFields((prev) => ({
                ...prev,
                schemeFilter: e.target.value,
              }));
              setPage(0);
            }}
            autoComplete="off"
          />
          <label htmlFor="fl11" className="floating-input-label">
            Search Scheme
          </label>
        </div>
      </div>
      <div className="tab-content">
        <div className="tab-pane fade in active">
          <div className="tabcontbox">
            <div className="datatable earnings-table" data-cy="earnings-table">
              {
                //if loading is true and teher is no error means waiting for data to come so show spinner
                schemeOverview?.loading && !schemeOverview.error ? (
                  <Spinner />
                ) : //else if laoding is now false but an error is there then show error
                !schemeOverview?.loading && schemeOverview.error ? (
                  <Error error={schemeOverview.error} />
                ) : (
                  //else if loading is not true and error also is not true, means there is response
                  <table className="table table-striped">
                    <thead>
                      <tr role="row">
                        <th colSpan="1" style={{ fontWeight: "bold" }}>
                          Date
                        </th>
                        <th colSpan="1" style={{ fontWeight: "bold" }}>
                          Scheme Number
                        </th>
                        <th colSpan="3" style={{ fontWeight: "bold" }}>
                          Scheme Name
                        </th>
                        <th colSpan="1" style={{ fontWeight: "bold" }}>
                          Header Count
                        </th>
                        <th colSpan="1" style={{ fontWeight: "bold" }}>
                          Item Count
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        //if data is present, show data
                        schemeOverview.data.content
                          ?.filter(
                            (obj) =>
                              !searchFields?.schemeFilter ||
                              obj?.schemeNumber
                                ?.toLowerCase()
                                ?.includes(
                                  searchFields?.schemeFilter?.toLowerCase()
                                ) ||
                              obj?.schemeName
                                ?.toLowerCase()
                                ?.includes(
                                  searchFields?.schemeFilter?.toLowerCase()
                                )
                          )
                          ?.slice(
                            page * rowsPerPage,
                            page * rowsPerPage + rowsPerPage
                          )?.length ? (
                          schemeOverview.data.content
                            ?.filter(
                              (obj) =>
                                !searchFields?.schemeFilter ||
                                obj?.schemeNumber
                                  ?.toLowerCase()
                                  ?.includes(
                                    searchFields?.schemeFilter?.toLowerCase()
                                  ) ||
                                obj?.schemeName
                                  ?.toLowerCase()
                                  ?.includes(
                                    searchFields?.schemeFilter?.toLowerCase()
                                  )
                            )
                            ?.slice(
                              page * rowsPerPage,
                              page * rowsPerPage + rowsPerPage
                            )
                            ?.map((obj, index) => {
                              return (
                                <tr key={index}>
                                  <td>
                                    {convertDateFormat(
                                      obj?.date?.split(" ")?.[0]
                                    )}
                                  </td>
                                  <td>{obj?.schemeNumber}</td>
                                  <td colSpan="3">{obj?.schemeName}</td>
                                  <td>{obj?.headerCount}</td>
                                  <td>{obj?.itemCount}</td>
                                </tr>
                              );
                            })
                        ) : (
                          //if the response is empty, show no data available
                          <tr>
                            <td colSpan={8}>No Data Available</td>
                          </tr>
                        )
                      }
                    </tbody>
                  </table>
                )
              }

              {schemeOverview?.data?.content?.filter(
                (obj) =>
                  !searchFields?.schemeFilter ||
                  obj?.schemeNumber
                    ?.toLowerCase()
                    ?.includes(searchFields?.schemeFilter?.toLowerCase()) ||
                  obj?.schemeName
                    ?.toLowerCase()
                    ?.includes(searchFields?.schemeFilter?.toLowerCase())
              )?.length > 0 && (
                <div className="scheme-overview-pagination">
                  <TablePagination
                    component={"div"}
                    rowsPerPageOptions={[10, 20, 50, 100]}
                    count={
                      schemeOverview?.data?.content?.filter(
                        (obj) =>
                          !searchFields?.schemeFilter ||
                          obj?.schemeNumber
                            ?.toLowerCase()
                            ?.includes(
                              searchFields?.schemeFilter?.toLowerCase()
                            ) ||
                          obj?.schemeName
                            ?.toLowerCase()
                            ?.includes(
                              searchFields?.schemeFilter?.toLowerCase()
                            )
                      )?.length
                    }
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={(event, newPage) => {
                      setPage(newPage);
                    }}
                    onRowsPerPageChange={(event) => {
                      setRowsPerPage(parseInt(event.target.value, 10));
                      setPage(0);
                    }}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SchemeCountTable;
